module.exports = __webpack_public_path__ + "img/idea.b65281c.jpg";